import { observable, action } from 'mobx'
import { Modal } from 'hljd'
import { hashHistory } from 'react-router'
import infoStore from './Info/store'
import spotStore from './Hotspot/store'
import { menuConfig } from './Menu/config'

class Store {
  @observable menus = menuConfig // 左侧菜单配置
  @observable isUnsave = false
  @observable getFieldsValue = () => {}

  // 切换菜单
  @action
  switchMenu = (path, curPath) => {
    if (this.isUnsave) {
      Modal.confirm({
        title: '提示',
        content: '检测到有未保存的内容，是否保存？',
        onOk: () => {
          if (curPath === menuConfig[2].to) {
            // 热点
            spotStore.onSave().then(() => {
              this.isUnsave = false
              hashHistory.push(path)
            })
          } else if (curPath === menuConfig[0].to) {
            // 基础
            infoStore.onBasicSave(this.getFieldsValue).then(() => {
              this.isUnsave = false
              hashHistory.push(path)
            })
          }
        }
      })
    } else {
      this.isUnsave = false
      hashHistory.push(path)
    }
  }
  @action
  onDo = () => {
    this.isUnsave = true
  }
}

export default new Store()
